import * as core from '../../../../../../../core'

import { query } from './cursor-net-roi.query'

export const RESOURCE = {
  payload: {
    alias: 'cursor.net.roi',
    description:
      'Estimated value generated after subtracting Cursor costs. Not yet implemented.',
    name: 'Cursor Net ROI',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
